export default __webpack_public_path__ + "assets/images/p_dashboard.d2e0883.png";